var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab2-box"},[_c('videoItem',{attrs:{"user":_vm.tab2User,"tab2CurrentShare":_vm.tab2CurrentShare,"idPix":"tab2-video"},on:{"dobClick":_vm.dobuleTab2Click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }